const currencySymbol = process.env.VUE_APP_DEFAULT_CURRENCY_SYMBOL;

const formatCurrency = {
  install: (Vue) => {
    Vue.prototype.$formatCurrency = (value, decimals = 2) => {
      if (value == null) {
        return "";
      }
      return `${parseFloat(value).toFixed(decimals)} ${currencySymbol} `;
    };
    Vue.prototype.$formatPercentage = (value) => {
      if (!value && value !== 0) return "-";
      return parseFloat(value).toFixed(2) + "%";
    };
  },
};

export default formatCurrency;
